export const SESSION_INITIALIZED = 'sessionInitialized';
export const SESSION_ESTABLISHED = 'sessionEstablished';
export const SESSION_SAVED = 'sessionSaved';
export const SESSION_LOGOUT = 'sessionLogOut';